import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=8f52a068"
import script from "./addModel.vue?vue&type=script&lang=js"
export * from "./addModel.vue?vue&type=script&lang=js"
import style0 from "./addModel.vue?vue&type=style&index=0&id=8f52a068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports